import { makeStyles } from "tss-react/mui";
import { constants } from "../../constants";

export const useStyles = makeStyles()((theme) => ({
    root: {
        alignSelf: "center",
        width: "100%",
        background: constants.color.white,
        display: "flex",
        flexDirection: "row",
        height: "auto",
        paddingTop: "60px",
        paddingBottom: "60px",
        "&.image_double": {
            minHeight: "1265px",
        },
        "&.image_single": {
            minHeight: "580px",
            "& .left": {
                height: "784px",
            },
        },
        "&.video": {
            minHeight: "795px",
        },
        position: "relative",
    },
    column: {
        display: "flex",
        width: "100%",
        maxWidth: "784px",
        "&.right": {
            width: "100%",
            maxWidth: "656px",
            height: "unset",
        },
        zIndex: 10,
    },
    leftCopy: {
        display: "flex",
        width: "100%",
        maxWidth: "639px",
        margin: "120px 0 0 142px",
        flexDirection: "column",

        "& img": {
            width: "100%",
            height: "639px",
        },

        "&.video": {
            width: "497px",
            marginTop: "169px",
            background: constants.color.white,
            padding: "58px 44px",
        },
    },
    rightImage: {
        display: "flex",
        width: "100%",
        height: "100%",
        alignItems: "flex-end",

        "& img": {
            width: "497px",
            height: "497px",
            margin: "0 0 120px 71px",
        },
    },
    rightCopy: {
        display: "flex",
        width: "438px",
        minHeight: "315px",
        flexDirection: "column",
        justifyContent: "left",
        textAlign: "left",
        marginLeft: "68px",
    },
    leftImage: {
        width: "100%",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
    },
    heading: {
        fontFamily: "Gotham Book",
        fontSize: "54px",
        fontWeight: 450,
        lineHeight: "62px",
        letterSpacing: "2px",
        textAlign: "left",
        color: constants.color.black,
        textTransform: "uppercase",
        "&.left": {
            marginTop: "43px",
        },
        "&.right": {
            marginTop: "0px",
        },
        "&.image_double": {
            marginTop: "42px",
        },
    },
    description: {
        fontFamily: "Galaxie Copernicus",
        fontSize: "16px",
        fontWeight: 500,
        lineHeight: "26px",
        textAlign: "left",
        marginTop: "16px",
        color: constants.color.black,
        "&.left": {
            marginTop: "43px",
        },
        "&.right": {
            marginTop: "16px",
        },
    },

    cta: {
        padding: 0,
        marginTop: "24px",
        borderBottom: `1px solid ${constants.color.alizarin}`,

        height: "21px",
        fontFamily: "Gotham Book",
        fontSize: "12px",
        fontWeight: 450,
        lineHeight: "18px",
        textAlign: "left",
        borderRadius: 0,
        color: constants.color.black,
        display: "inline-block",
        textTransform: "uppercase",
        textDecoration: "none",
    },

    backgroundAsset: {
        width: "100%",
        height: "100%",
        position: "absolute",
        zIndex: 0,
        top: 0,
        left: 0,
        "& video, img": {
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "left",
        },
    },
}));
